import React from 'react';
import CsvTable from './CsvTable';
import { CsvProvider, useCsvEditor } from './context';
import { Grid } from '@material-ui/core';
import Icon from '../../../Icon';
import Page from '../../../../page';
import pathUtil from '../../../../utils/pathUtil';

var CsvEditor = function CsvEditor(_ref) {
  var workspace = _ref.workspace,
      path = _ref.path;

  var _useCsvEditor = useCsvEditor(),
      save = _useCsvEditor.save,
      isSaving = _useCsvEditor.isSaving,
      canSave = _useCsvEditor.canSave,
      undo = _useCsvEditor.undo,
      canUndo = _useCsvEditor.canUndo,
      redo = _useCsvEditor.redo,
      canRedo = _useCsvEditor.canRedo;

  return React.createElement("div", null, React.createElement(Page.ToolBar, {
    icon: {
      type: 'close',
      onClick: function onClick() {
        return onClose();
      }
    },
    leftChildren: pathUtil.getFileCaption(path),
    centerChildren: React.createElement(Grid, {
      container: true,
      spacing: 1
    }, React.createElement(Grid, {
      item: true
    }, React.createElement(Icon, {
      type: isSaving ? 'loading' : 'save',
      onClick: save,
      disabled: !canSave
    })), React.createElement(Grid, {
      item: true
    }, React.createElement(Icon, {
      type: "undo",
      onClick: undo,
      disabled: !canUndo
    })), React.createElement(Grid, {
      item: true
    }, React.createElement(Icon, {
      type: "redo",
      onClick: redo,
      disabled: !canRedo
    }))),
    color: "navbar"
  }), React.createElement(CsvTable, {
    workspace: workspace,
    path: path
  }));
};

var CsvEditorWrapper = function CsvEditorWrapper(props) {
  return React.createElement(CsvProvider, null, React.createElement(CsvEditor, props));
};

export default CsvEditorWrapper;